export var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["IN_PROGRESS"] = "IN_PROGRESS";
    RecordingStatus["COMPLETED"] = "COMPLETED";
    RecordingStatus["FAILED"] = "FAILED";
})(RecordingStatus || (RecordingStatus = {}));
export var TranscriptionStatus;
(function (TranscriptionStatus) {
    TranscriptionStatus["COMPLETED"] = "COMPLETED";
    TranscriptionStatus["FAILED"] = "FAILED";
})(TranscriptionStatus || (TranscriptionStatus = {}));
export var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus["ACTIVE"] = "ACTIVE";
    AssistantStatus["PROCESSED"] = "PROCESSED";
    AssistantStatus["COMPLETED"] = "COMPLETED";
    AssistantStatus["ERROR"] = "ERROR";
})(AssistantStatus || (AssistantStatus = {}));
export var ConferenceStatus;
(function (ConferenceStatus) {
    ConferenceStatus["ACTIVE"] = "ACTIVE";
    ConferenceStatus["ENDED"] = "ENDED";
})(ConferenceStatus || (ConferenceStatus = {}));
export var CallDirection;
(function (CallDirection) {
    CallDirection["INBOUND"] = "INBOUND";
    CallDirection["OUTBOUND"] = "OUTBOUND";
})(CallDirection || (CallDirection = {}));
export var OutboundCallStatus;
(function (OutboundCallStatus) {
    OutboundCallStatus["STARTED"] = "started";
    OutboundCallStatus["ENDED"] = "ended";
})(OutboundCallStatus || (OutboundCallStatus = {}));
export var ParticipantRole;
(function (ParticipantRole) {
    ParticipantRole["CALLER"] = "caller";
    ParticipantRole["CALLEE"] = "callee";
})(ParticipantRole || (ParticipantRole = {}));
/**
 * Call lifecycle event names, logged into the scratchpad event log
 * at each lifecycle moment for both MAIN and SEGMENT connections. Single
 * source of truth so every write site (Node dispatch/Twilio-lookup/webhook
 * handlers) uses the same literal strings.
 *
 * CALL_START and RING_START share one write site (the real SIP dial), as do
 * RING_END and AGENT_START (the real pickup) — both pairs are logged
 * together, same timestamp, since today's signals can't tell them apart.
 */
export var CallLifecycleEvent;
(function (CallLifecycleEvent) {
    CallLifecycleEvent["DISPATCH"] = "DISPATCH";
    CallLifecycleEvent["CALL_START"] = "CALL_START";
    CallLifecycleEvent["RING_START"] = "RING_START";
    CallLifecycleEvent["RING_END"] = "RING_END";
    CallLifecycleEvent["AGENT_START"] = "AGENT_START";
    CallLifecycleEvent["AGENT_END"] = "AGENT_END";
    CallLifecycleEvent["CALL_END"] = "CALL_END";
})(CallLifecycleEvent || (CallLifecycleEvent = {}));
/** Which connection within a call a CallLifecycleEvent describes. */
export var CallConnectionType;
(function (CallConnectionType) {
    CallConnectionType["MAIN"] = "MAIN";
    CallConnectionType["SEGMENT"] = "SEGMENT";
})(CallConnectionType || (CallConnectionType = {}));
/**
 * Reasons why a session ended or was escalated
 * Used across voice calls and SMS conversations for handoff handling
 */
export var SessionCompletionReason;
(function (SessionCompletionReason) {
    SessionCompletionReason["AGENT_TRANSFER"] = "agent_transfer";
    SessionCompletionReason["USER_DISCONNECT"] = "user_disconnect";
    SessionCompletionReason["ESCALATION"] = "escalation";
    SessionCompletionReason["TIMEOUT"] = "timeout";
    SessionCompletionReason["ERROR"] = "error";
    SessionCompletionReason["COMPLETED"] = "completed";
    SessionCompletionReason["VOICEMAIL"] = "voicemail";
    SessionCompletionReason["IVR"] = "ivr";
    SessionCompletionReason["UNAVAILABLE"] = "unavailable";
})(SessionCompletionReason || (SessionCompletionReason = {}));
/**
 * Who triggered the end of a call. Stamped by the voice agent at the
 * disconnect/end trigger (the recording keeps rolling during teardown).
 * Single source of truth — the type, DTO validators, and event schema all
 * derive from this list; values match the ConferenceEndedBy Prisma enum.
 */
export const CONFERENCE_ENDED_BY_VALUES = [
    'CALLER',
    'AGENT',
    'STAFF',
    'SYSTEM',
];
/**
 * Values allowed on `communication.conference.ended`. Single source of truth —
 * the event-schema zod enum and the api-side publish gate both derive from
 * this array. Add a value here first; downstream call sites break at compile
 * time until they're updated.
 */
export const CONFERENCE_ENDED_COMPLETION_REASON_VALUES = [
    'agent_transfer',
    'user_disconnect',
    'voicemail',
    'ivr',
    'unavailable',
];
//# sourceMappingURL=conference.js.map